module.exports = __webpack_public_path__ + "assets/img/DS-master (13).54186320.jpg";